/**
 * Gets dynamic styles for the option container based on selection and position
 * @param {boolean} isSelected - Whether the option is selected
 * @param {boolean} isFirstOption - Whether this is the first option in the list
 * @returns {Object} - Style object for the option container
 */
export const getOptionStyles = (isSelected, isFirstOption) => {
  return {
    display: 'flex !important',
    padding: '4px 20px !important',
    marginTop: isFirstOption ? '-12px !important' : '-8px !important',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    alignSelf: 'stretch !important',
    borderBottom: 'none !important',
    backgroundColor: isSelected ? '#F3E8FF !important' : 'transparent',
    width: '100%',
    cursor: 'pointer',
  };
};

/**
 * Gets styles for the option details typography
 * @returns {Object} - Style object for the typography component
 */
export const getOptionDetailsStyles = () => {
  return {
    color: 'var(--Greyscale---grey-110, #333)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '22px',
    letterSpacing: '0.28px',
    marginLeft: '24px',
  };
};

